<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12">
        <QTextField v-model="item.Name" :label="$t('servicesystem.common_objects.counter.name')" :rules="[requiredRule]"
          maxlength="50" :externaledit="editMode" @FocusState="handleFocus">
        </QTextField>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <QCheckboxInput v-model="item.Global" :label="$t('servicesystem.common_objects.counter.global')"
          :externaledit="editMode" @FocusState="handleFocus">
        </QCheckboxInput>
      </v-col>
    </v-row>
    <v-row v-if="item.Id"> <!-- No point in being able to create inactive counters -->
      <v-col cols="12">
        <QCheckboxInput v-model="item.Active" :label="$t('servicesystem.common_objects.counter.active')"
          :externaledit="editMode" @FocusState="handleFocus">
        </QCheckboxInput>
      </v-col>
    </v-row>
  </v-container>
</template>


<script>
export default {
  name: "CounterEditContent",
  props: {
    item: Object,
    editMode: Boolean,
    handleFocus: Function,
  },
  components: {},
  mixins: [],

  data() {
    return {
    };
  },

  mounted() { },

  methods: {
  },

  computed: {
  },

  watch: {},
};
</script>


<style lang='scss'></style>